<div class="carousel">
	<div
		class="track-wrapper"
		#wrapper
	>
		<div
			class="track"
			#track
			[style.transform]="trackTransform()"
		>
			<ng-content />
		</div>
	</div>

	@if (isOverflow()) {
		@if (!isShowPrevBtn()) {
			<app-button
				class="nav-button nav-button-prev"
				appearance="flat"
				size="xs"
				[iconSize]="arrowSize()"
				shape="square"
				iconStart="chevron-left"
				(clicked)="goPrev()"
			/>
		}

		@if (!isShowNextBtn()) {
			<app-button
				class="nav-button nav-button-next"
				appearance="flat"
				size="xs"
				[iconSize]="arrowSize()"
				shape="square"
				iconStart="chevron-right"
				(clicked)="goNext()"
			/>
		}
	}
</div>
